export default __webpack_public_path__ + "static/media/APE.69084d3e.png";